import { stringIncludesInsensitiveAccents } from '../../utils/normalizeForSearch';

/**
 * Add IDs to editFormUrls items using url as unique identifier
 * @param {Array<ApiDashboardEditFormUrls>} items - The items to add IDs to
 * @returns {Array<DashboardEditFormUrlsWithId>} Items with IDs
 */
export const addIdsToEditFormUrls = (items) => items.map((item, index) => ({
  ...item,
  id: item.url || `edit-form-${index}`,
}));

/**
 * Filter editFormUrls by search value (searches in lib only)
 * @param {Array<DashboardEditFormUrlsWithId>} items - The items to filter
 * @param {string} searchValue - The search value
 * @returns {Array<DashboardEditFormUrlsWithId>} Filtered items
 */
export const filterEditFormUrlsBySearch = (items, searchValue) => {
  if (!searchValue) return items;

  return items.filter((item) => stringIncludesInsensitiveAccents(item.lib, searchValue));
};
